export var SUCCESS_STATUS_CODE = 200;
export var asText = function (value) { return String(value !== null && value !== void 0 ? value : '').trim(); };
